import Blue from "~/core";
import Splide from '@splidejs/splide';

new Blue({
  name: "AviationFeatureSlider",
  selector: ".aviation-feature-slider",
  setup(aviationFeatureSlider) {
    const shouldSetTimeout = document.querySelector("html").classList.contains("kentico-page-builder");
    if (shouldSetTimeout) {
      updateSplideMethodList({
        initAviationFeatureSliderSplide
      });
    } else {
        initAviationFeatureSliderSplide();
    }    
  },
});

function initAviationFeatureSliderSplide() {
    var splideElement = document.querySelector('.aviation-feature-slider .splide');

    if (splideElement) {

        const aviationFeatureSliderSplide = new Splide(splideElement, {
            type: 'loop',
            perPage: 3,
            perMove: 3,
            pagination: false,
            gap: '1rem',
            fixedWidth: 340,
            mediaQuery: 'min',
            breakpoints: {
                728: {
                    gap: '1.85rem',
                    fixedWidth: 450
                },
            },
        });
        aviationFeatureSliderSplide.mount();

        const nextButton = document.querySelector('.aviation-feature-slider .aviation__splide-arrow--next');
        const prevButton = document.querySelector('.aviation-feature-slider .aviation__splide-arrow--prev');

        nextButton.addEventListener('click', (e) => {
            e.preventDefault();
            aviationFeatureSliderSplide.go(aviationFeatureSliderSplide.index + 1);
        });

        prevButton.addEventListener('click', (e) => {
            e.preventDefault();
            aviationFeatureSliderSplide.go(aviationFeatureSliderSplide.index - 1);
        });
    }
}

function updateSplideMethodList(functionList) {
  if(window.splideMethods)
  {
    Object.assign(window.splideMethods, functionList);
  }
  else {
    window.splideMethods = functionList;
  }
}